import {createAction, props} from '@ngrx/store';

export const updateClient = createAction("updateClient",props<{payload:any}>());
export const fetchClient = createAction("fetchClient",props<{payload:any}>());